import type { FC, ReactNode } from "react";
import { useMemo } from "react";

import _ from "lodash";

import type { IEllipsisDropdownItemProps } from "@similarweb/ui-components";
import { Dropdown, EllipsisDropdownItem } from "@similarweb/ui-components";
import { CellContainer, StyledArrowIcon, KeywordWrapper, ArrowKeywordWrapper } from "../Utils/quickNavStyledComponents";

import { UpgradeLink } from "./UpgradeLink";
import { allTrackers } from "app/services/track/track";

export interface ISearchKeywordCellPopUpDropDown {
    quickNavItems: Array<ReactNode | IEllipsisDropdownItemProps>;
    onNavItemClick: (item: FixmeType, value: string) => void;
    scrollAreaMinHeight?: number;
    dropDownWidth?: string;
    value: string;
    dropdownPopupPlacement?: string;
    appendTo?: string;
    className?: string;
}

export const SearchKeywordCellPopUpDropDown: FC<ISearchKeywordCellPopUpDropDown> = ({
    value,
    quickNavItems,
    onNavItemClick,
    scrollAreaMinHeight = 274,
    dropDownWidth = "241px",
    dropdownPopupPlacement,
    appendTo,
    className,
}) => {
    const isGridUpgrade = value === "grid.upgrade";

    const onDropDownClickTracking = () => {
        allTrackers.dispatchTrackEvent("Drop Down", "click", `Quick Nav/${value || ""}`);
        if (isGridUpgrade) {
            return <UpgradeLink hookType="keywords" />;
        }
    };

    const defaultClasses = useMemo(() => {
        return ["DropdownContent-container", "search-cell-dropdown", "SearchKeywordCellPopUpDropDown", className]
            .filter(Boolean)
            .join(" ");
    }, [className]);

    const contextItems = [
        <ArrowKeywordWrapper key="ArrowKeywordWrapper">
            <KeywordWrapper key={value}>{value}</KeywordWrapper>
            <span>
                <StyledArrowIcon iconName={"arrow"} />
            </span>
        </ArrowKeywordWrapper>,
        ...quickNavItems,
    ];

    if (isGridUpgrade) {
        return <UpgradeLink />;
    }

    return (
        <CellContainer onClick={() => onDropDownClickTracking()}>
            <Dropdown
                itemsComponent={EllipsisDropdownItem}
                onClick={(item) => onNavItemClick(item, value)}
                cssClassContainer={defaultClasses}
                scrollAreaMinHeight={scrollAreaMinHeight}
                onToggle={_.noop}
                width={dropDownWidth}
                dropdownPopupPlacement={dropdownPopupPlacement}
                appendTo={appendTo}
            >
                {contextItems}
            </Dropdown>
        </CellContainer>
    );
};

SearchKeywordCellPopUpDropDown.displayName = "SearchKeywordCellPopUpDropDown";
